"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProductDetailsIconButton = exports.StyledProductNameCellContent = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledProductNameCellContent = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
  height: 100%;

  p {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: inherit;
  }
`;
exports.StyledProductDetailsIconButton = (0, styled_components_1.default)(material_1.IconButton) `
  flex: 0 0 2.5rem;
  height: 2.5rem;
  align-self: center;
`;
